var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5907 45.953V37.5389C38.5907 37.2414 38.3381 37 38.0269 37C37.7158 37 37.4632 37.2414 37.4632 37.5389V45.953C37.4632 46.2505 37.7158 46.4919 38.0269 46.4919C38.3381 46.4919 38.5907 46.2505 38.5907 45.953ZM42.5368 45.953V37.5389C42.5368 37.2414 42.2842 37 41.9731 37C41.6619 37 41.4093 37.2414 41.4093 37.5389V45.953C41.4093 46.2505 41.6619 46.4919 41.9731 46.4919C42.2842 46.4919 42.5368 46.2505 42.5368 45.953ZM46.7648 35.2832C46.4536 35.2832 46.2011 35.5246 46.2011 35.8221V48.0576C46.2011 48.5232 45.5812 48.9222 45.0736 48.9222H34.7034C34.2045 48.9222 33.7989 48.5345 33.7989 48.0576V35.8221C33.7989 35.5246 33.5464 35.2832 33.2352 35.2832C32.924 35.2832 32.6715 35.5246 32.6715 35.8221V48.0576C32.6715 49.1286 33.583 50 34.7034 50H45.0736C46.1379 50 47.3285 49.1693 47.3285 48.0576V35.8221C47.3285 35.5246 47.076 35.2832 46.7648 35.2832ZM48.4363 32.9946H44.228V30.5389C44.228 30.2414 43.9754 30 43.6643 30H36.3357C36.0246 30 35.772 30.2414 35.772 30.5389V32.9946H31.5637C31.2526 32.9946 31 33.236 31 33.5334C31 33.8309 31.2526 34.0723 31.5637 34.0723H48.4363C48.7474 34.0723 49 33.8309 49 33.5334C49 33.236 48.7474 32.9946 48.4363 32.9946ZM43.1005 32.9946H36.8995V31.0778H43.1005V32.9946Z",
    fill: "#292929",
    stroke: "#292929",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.2053 27.429C12.6913 38.7116 16.557 53.1387 27.8396 59.6527C39.1222 66.1667 53.5493 62.301 60.0633 51.0184C66.5773 39.7357 62.7116 25.3087 51.429 18.7947",
    stroke: "#292929",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.542 53.958C72.5269 40.1277 67.7883 22.4429 53.958 14.458C40.1277 6.47307 22.4429 11.2117 14.458 25.042C6.47308 38.8723 11.2117 56.5571 25.042 64.542",
    stroke: "#292929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinDelete);
export default __webpack_public_path__ + "static/media/bin-delete.aa3504fbbba7be65a7f346930a08436a.svg";
export { ForwardRef as ReactComponent };